function setCookie(name, value, expires) {
  var domain = document.domain,
    cookie = name + '=' + value + '; Expires=' + expires + ';'
  if (domain !== 'localhost') {
    cookie += ' Path=/; Domain=' + domain + ';'
  }
  document.cookie = cookie
}

function remember(rememberMe) {
  setCookie(
    this,
    'rememberMe',
    rememberMe === true ? 'true' : 'false',
    rememberMe === true ? 12096e5 : undefined
  )
}

function set(name, value, expires) {
  if (value) {
    setCookie(name, value, expires)
  }
}

function get(name) {
  var i,
    ii,
    cookie = document.cookie

  cookie = cookie
    .replace(/;\s+/g, ';')
    .split(';')
    .map(function(s) {
      return s.replace(/\s+=\s+/g, '=').split('=')
    })

  for (i = 0, ii = cookie.length; i < ii; i++) {
    if (cookie[i][0] && cookie[i][0] === name) {
      return cookie[i][1]
    }
  }

  return null
}

function exists(name) {
  return get(name)
}

function remove(name) {
  setCookie(name, '', 'Thu, 01 Jan 1970 00:00:00 UTC')
}

export default {
  setCookie,
  remember,
  set,
  get,
  exists,
  remove
}
